import ApiService from '@/common/api.service'

export default {
  getConfigData () {
    return new Promise((resolve, reject) => {
      ApiService.query('/choice-item/list').then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
